var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitesvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20745 5.7487L6.83245 7.9987M14.1855 0.52195C14.2606 0.497391 14.3415 0.493349 14.4189 0.510287C14.4963 0.527224 14.5672 0.564458 14.6233 0.617732C14.6795 0.671006 14.7187 0.738172 14.7364 0.811552C14.7542 0.884933 14.7498 0.961568 14.7238 1.0327L10.034 13.7302C10.0059 13.8061 9.9544 13.8723 9.88616 13.9201C9.81792 13.9679 9.73608 13.9952 9.65125 13.9985C9.56643 14.0017 9.48254 13.9807 9.41046 13.9382C9.33838 13.8957 9.28145 13.8337 9.24704 13.7602L6.69866 8.3287C6.65578 8.23838 6.57946 8.16607 6.48412 8.12545L0.750868 5.71045C0.673518 5.67773 0.608301 5.62379 0.563642 5.5556C0.518983 5.48741 0.496934 5.4081 0.500343 5.32791C0.503753 5.24772 0.532464 5.17035 0.582768 5.10578C0.633072 5.04121 0.702658 4.99242 0.782535 4.9657L14.1855 0.52195Z",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitesvg);
export default __webpack_public_path__ + "static/media/invitesvg.420d80d4959945da78c792c42b12a9e1.svg";
export { ForwardRef as ReactComponent };